/**
 * Section-number match shared by Add Specs and the project .docx import:
 * is a LIVE (non-archived) project spec already holding this section number?
 */
import { isArchived } from '../lib/archive';

export const sameCsi = (a?: string, b?: string) =>
  !!(a || '').trim() && (a || '').trim().toLowerCase() === (b || '').trim().toLowerCase();

/** Live specs in `existing` that hold `csiNumber` (case/space-insensitive).
 *  A blank number never matches. */
export function liveHoldersOfSection<T extends { csiNumber?: string; archivedAt?: string | null }>(
  existing: ReadonlyArray<T>,
  csiNumber: string | undefined
): T[] {
  return existing.filter((s) => !isArchived(s) && sameCsi(s.csiNumber, csiNumber));
}
